import { ROLE_SLUGS, isUserRole } from '@/utils/roles'

export const changeDocumentTitle = () => {
  if (isUserRole(['real_trade_lab']) || isUserRole(['trial_trade_lab_202409'])) {
    document.title = '実践トレードラボ／神藤塾'
  } else if (isUserRole(['shindo'])) {
    document.title = '神藤塾'
  } else {
    document.title = '神藤塾'
  }
}
